import { APPLICATION_DOCUMENT_ROUTES } from './document';
import { APPLICATION_SYSTEM_ROUTES } from './system';

export { APPLICATION_DOCUMENT_BASE_URL } from './document';
export {
  APPLICATION_SESSION_EXPIRED_BASE_URL,
  APPLICATION_WORKFLOW_BASE_URL,
} from './system';

export const APPLICATION_ROUTES = {
  ...APPLICATION_DOCUMENT_ROUTES,
  ...APPLICATION_SYSTEM_ROUTES,
} as const;
